/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { BrandsActiveDictionaryList } from '../model/brandsActiveDictionaryList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DictionaryService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Słownikowa aktywnych marek
     *  - __Type__: custom - __PageSize__: 25 - __Entity__: SalesMailer\\Domain\\Brand - __OperationId__: BrandsActiveDictionaryListQueryOperationHandler - __OperationName__: ListQuery - __OutputModelName__: BrandsActiveDictionaryListItem - __ListModelName__: BrandsActiveDictionaryList - __DefaultSortOrder__:  - __Name__:  - __Path__: /backoffice/dictionaries/brands - __Method__: GET - __Description__:  - __Summary__: Słownikowa aktywnych marek - __RouteName__: GETBrandsActiveDictionaryListItemListQuery - __Hash__: c89c75b550990c88dc126af0cfa34154 - __Input__:  - __Output__: NomaSolutions\\API\\Model\\DictionaryItem - __InputGroups__:  - __OutputGroups__:  - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public brandsActiveDictionaryListQueryOperationHandler(observe?: 'body', reportProgress?: boolean): Observable<BrandsActiveDictionaryList>;
    public brandsActiveDictionaryListQueryOperationHandler(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrandsActiveDictionaryList>>;
    public brandsActiveDictionaryListQueryOperationHandler(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrandsActiveDictionaryList>>;
    public brandsActiveDictionaryListQueryOperationHandler(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BrandsActiveDictionaryList>(`${this.basePath}/api/backoffice/dictionaries/brands`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
